const AppPeace = () =>
    import('@/layout/AppPeace.vue')
const ReservateMeeting = () =>
    import('@/views/meetingList/reservateMeeting.vue')
const MeetingList = () =>
    import('@/views/meetingList/meetinglist.vue')
const MeetingDetail = () =>
    import('@/views/meetingList/meetingDetail.vue')
export default {
    path: '/',
    component: AppPeace,
    sort: 3,
    meta: {
        title: '预约会议',
        requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
    },
    children: [{
            path: '/meeting/reservateMeeting',
            name: 'reservateMeeting',
            component: ReservateMeeting
        }, {
            path: '/meeting/meetinglist',
            name: 'meetingList',
            component: MeetingList
            // meta: {
            //     keepAlive: true 
            // }
        }, {
            path: '/meeting/meetingDetail',
            name: 'meetingDetail',
            component: MeetingDetail
        },

    ]
}